
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { ListViewModel } from '@/definitions/view-models';
import { autoUpdateHelper } from '@/api/common/auto-update-helper';
import { Line } from '@/api/models/Line';
import { LinesFilter } from '@/api/models/LinesFilter';
import { aclModule } from '@/store/acl';
import { dataAssetsModule } from '@/store/application/data.assets.module';
import { PagePaths } from '@/store/application/page.definitions';
import { pageModule } from '@/store/application/page.module';
import { multisidebarModule } from '@/store/multisidebar';
import { MultisidebarItemTypes } from '@/store/multisidebar/types';
import NBaseBar from '@/uikit/bars/NBaseBar.vue';
import NButton from '@/uikit/buttons/NButton.vue';
import NButtonGroup from '@/uikit/buttons/NButtonGroup.vue';
import { IFormLayoutItem } from '@/uikit/forms/NForm.vue';
import EntityBlank from '@/components/common/EntityBlank.vue';
import FilterSection from '@/components/common/filter/FilterSection.vue';
import SortDropdown from '@/components/common/SortDropdown.vue';
import Statistics from '@/components/common/Statistics.vue';
import { getLineFilters } from '@/pages/lines/LineFilters';
import LinesTable from '@/pages/lines/LinesTable.vue';
import ListPage from '@/pages/ListPage.vue';

@Options({
  name: 'LinesPage',
  components: {
    EntityBlank,
    FilterSection,
    LinesTable,
    ListPage,
    NBaseBar,
    NButton,
    NButtonGroup,
    SortDropdown,
    Statistics
  }
})
export default class LinesPage extends Vue {
  @Prop({ type: String, required: true })
  tab!: string;

  get smallFilterLayout(): IFormLayoutItem[] {
    return getLineFilters({ small: true });
  }

  get bigFilterLayout(): IFormLayoutItem[] {
    return getLineFilters({ small: false });
  }

  get selectedItemIds(): number[] {
    return this.sidebarModule.items.filter((v) => v.type === MultisidebarItemTypes.Lines).map((v) => v.model.item.id);
  }

  get sidebarModule() {
    return multisidebarModule;
  }

  get state() {
    return pageModule.getPageStateByTab(PagePaths.Lines, this.tab);
  }

  get module() {
    return pageModule.getPageModule(this.state) as unknown as ListViewModel<Line, LinesFilter>;
  }

  get modelAcl() {
    this.module.aclModelName = 'line';
    return aclModule.getModelAcl(this.module);
  }

  get sortTypes(): any[] {
    return dataAssetsModule.getSortTypes({ created_date: true }).map((v) => ({ ...v, label: this.$t(v.i18n_label) }));
  }

  @Watch('module.filter.current', { deep: true })
  handleFiltersChange() {
    this.module.get();
  }

  handleCreate() {
    this.sidebarModule.addNewItemByType(MultisidebarItemTypes.Lines);
  }

  mounted() {
    autoUpdateHelper.addListInstance(this.module);
  }
}
